import { render } from "./CheckUpResultDetail.vue?vue&type=template&id=0532f280"
import script from "./CheckUpResultDetail.vue?vue&type=script&lang=js"
export * from "./CheckUpResultDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__